// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorPage__iTQf8 {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.errorPageTitle__XoYti {
  font-size: 32px;
  font-weight: 700;
  line-height: 41.6px;
  letter-spacing: -0.32px;
  color: #222;
  text-transform: uppercase;
  text-align: center;
  max-width: 650px;
}
@media (max-width: 850px) {
  .errorPageTitle__XoYti {
    font-size: 28px;
    line-height: 32px;
    max-width: 550px;
  }
}

.errorPageDescription__cp9EP {
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  color: #4a4a4a;
  text-align: center;
  margin-top: 20px;
  max-width: 645px;
}
@media (max-width: 850px) {
  .errorPageDescription__cp9EP {
    font-size: 28px;
    line-height: 32px;
    max-width: 545px;
  }
}

.errorPageActions___Cwqb {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.errorPageActionsBtn__c6Hr2 {
  width: 195px;
  border-radius: 0;
}

.switchCustomerBtn__SXxcj {
  margin-left: 25px;
}

.sidebarPanel__J9Nvi {
  width: 90px;
  height: 100vh;
  padding-top: 25px;
  display: flex;
  justify-content: center;
  background-color: #2c2d31;
  position: fixed;
  top: 0;
  left: 0;
}

.errorImageWrapper__ImT3D {
  position: relative;
  margin-top: 50px;
}

@media (max-width: 850px) {
  .errorImage__u5JOv {
    max-width: 545px;
  }
}

.errorImageWrapperText__DbYKN {
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  color: #3c97aa;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}

.supportLink__Pl7WI {
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  color: #3c97aa;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  margin-top: 25px;
}
.supportLink__Pl7WI:hover {
  color: #17b5d6;
}
.supportLink__Pl7WI:disabled {
  color: #9dcbd4;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Root/components/Error401/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAzEF;AA2EE;EAVF;IAWI,eAAA;IACA,iBAAA;IACA,gBAAA;EAxEF;AACF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAxEF;AA0EE;EATF;IAUI,eAAA;IACA,iBAAA;IACA,gBAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAvEF;;AA0EA;EACE,YAAA;EACA,gBAAA;AAvEF;;AA0EA;EACE,iBAAA;AAvEF;;AA0EA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;AAvEF;;AA0EA;EACE,kBAAA;EACA,gBAAA;AAvEF;;AA2EE;EADF;IAEI,gBAAA;EAvEF;AACF;;AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AAvEF;;AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAvEF;AAyEE;EACE,cAAA;AAvEJ;AA0EE;EACE,cAAA;AAxEJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.errorPage {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.errorPageTitle {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 41.6px;\n  letter-spacing: -0.32px;\n  color: #222;\n  text-transform: uppercase;\n  text-align: center;\n  max-width: 650px;\n\n  @media (max-width: 850px) {\n    font-size: 28px;\n    line-height: 32px;\n    max-width: 550px;\n  }\n}\n\n.errorPageDescription {\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 28px;\n  color: #4a4a4a;\n  text-align: center;\n  margin-top: 20px;\n  max-width: 645px;\n\n  @media (max-width: 850px) {\n    font-size: 28px;\n    line-height: 32px;\n    max-width: 545px;\n  }\n}\n\n.errorPageActions {\n  display: flex;\n  justify-content: center;\n  margin-top: 50px;\n}\n\n.errorPageActionsBtn {\n  width: 195px;\n  border-radius: 0;\n}\n\n.switchCustomerBtn {\n  margin-left: 25px;\n}\n\n.sidebarPanel {\n  width: 90px;\n  height: 100vh;\n  padding-top: 25px;\n  display: flex;\n  justify-content: center;\n  background-color: #2c2d31;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.errorImageWrapper {\n  position: relative;\n  margin-top: 50px;\n}\n\n.errorImage {\n  @media (max-width: 850px) {\n    max-width: 545px;\n  }\n}\n\n.errorImageWrapperText {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 28px;\n  color: #3c97aa;\n  text-align: center;\n  text-transform: uppercase;\n  width: 100%;\n  position: absolute;\n  bottom: 30px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.supportLink {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 12px;\n  color: #3c97aa;\n  text-align: center;\n  text-transform: uppercase;\n  text-decoration: none;\n  margin-top: 25px;\n\n  &:hover {\n    color: #17b5d6;\n  }\n\n  &:disabled {\n    color: #9dcbd4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorPage": `errorPage__iTQf8`,
	"errorPageTitle": `errorPageTitle__XoYti`,
	"errorPageDescription": `errorPageDescription__cp9EP`,
	"errorPageActions": `errorPageActions___Cwqb`,
	"errorPageActionsBtn": `errorPageActionsBtn__c6Hr2`,
	"switchCustomerBtn": `switchCustomerBtn__SXxcj`,
	"sidebarPanel": `sidebarPanel__J9Nvi`,
	"errorImageWrapper": `errorImageWrapper__ImT3D`,
	"errorImage": `errorImage__u5JOv`,
	"errorImageWrapperText": `errorImageWrapperText__DbYKN`,
	"supportLink": `supportLink__Pl7WI`
};
module.exports = ___CSS_LOADER_EXPORT___;
